import useGetApi from 'src/api/useGetApi';

export interface OCRResult {
  id: string;
  vendor: string;
  modelVersion: string;
  status: string;
  extractedText: string[] | null;
  documentAnalysis?: Record<string, unknown> | null;
  error: string | null;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse {
  id: string;
  originalName: string;
  mimeType: string;
  s3Url: string;
  ocrResults: OCRResult[];
}

const useAttachmentOcrResults = (
  inboundEmailId: string,
  attachmentId: string,
  enabled = true,
) => {
  return useGetApi<ApiResponse>({
    endpoint: `communications/inbound-emails/${inboundEmailId}/attachments/${attachmentId}/ocr-results`,
    options: {
      enabled,
    },
  });
};

export default useAttachmentOcrResults;
